<script lang="ts">
import Vue, { CreateElement, RenderContext, VNode } from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

// The single definition of the Client Access badge. Two different statements render it:
// "this contact is a client user" (via ContactMemberChip) and "this contact is granted
// access to this occupier" (the contact record's occupiers card). Keeping one component
// means the label and colour can't drift between them.
export default Vue.extend({
  name: 'ClientAccessChip',

  functional: true,

  render (h: CreateElement, { data }: RenderContext): VNode {
    return h(CommonChip, {
      attrs: { color: 'warning' },
      class: [data.staticClass, data.class],
    }, [
      h('span', 'Client Access'),
    ]);
  },
});
</script>
